var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    [
      _vm.responseDescription
        ? _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _c("div", [_vm._v(_vm._s(_vm.responseDescription))]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.responseStatus, function (status, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c("w-col", { attrs: { xs: "12" } }, [
              status.StatusReasonCode
                ? _c("div", [
                    _vm._v(_vm._s(_vm.statusReasonCodeToString(status))),
                  ])
                : _vm._e(),
              status.StatusReason
                ? _c("div", [_vm._v(_vm._s(status.StatusReason))])
                : _vm._e(),
            ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }